/**
 * Risk Posture Page (Pillar 1: IARPM)
 * Identity & Access Risk Posture Management
 *
 * This page provides a unified view of identity risk across the organization.
 */

import React from 'react';
import { Box } from '@mui/material';
import { useUserMetadata } from '../context/UserMetadataContext';
import RiskPostureDashboard from '../components/Profile360/components/RiskPostureDashboard';
import { PageHeader } from '../components/shared';

const RiskPosturePage = () => {
  const { userMetadata } = useUserMetadata();
  const tenantName = userMetadata?.company || 'trustx';

  return (
    <Box>
      <PageHeader
        title="Risk Posture"
        description="Identity & Access Risk Posture Management — Unified view of identity risk across your organization"
        pillarId="risk"
      />

      <RiskPostureDashboard tenantName={tenantName} />
    </Box>
  );
};

export default RiskPosturePage;
